var map = {
	"./app-news.png": 20157,
	"./food-news.png": 50460,
	"./news-02.png": 64708,
	"./news_01.jpg": 21661,
	"./news_02.jpg": 11762,
	"./news_03.jpg": 96047,
	"./news_04.jpg": 1732
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52256;